import { h } from 'preact';
import './index.less';

const ERROR = 'INTERNAL_SERVER_ERROR';
const OTPError = ({ error }) => (
  <div className="errorMessage">
    {!error ||
    !Object.keys(error).length ||
    !error.message ||
    (error.reason && error.reason === ERROR)
      ? 'Something went wrong, could not send OTP'
      : error.message}
  </div>
);

export default OTPError;
